const WLWishlistFunctions = {
  addToList: (target, product, _lid = false) => {
    function onSwymLoadCallback(swat) {
      // Please make all SWYM-related API calls inside this function.
      // You can use the swat argument within this scope.
      if (swat) {
        let lid = target.dataset.lid ? target.dataset.lid : target.closest('unico-favorite-button').dataset.lid;
        // Define success callback
        let onSuccess = function (addedListItem){
          // Success response is the added product. 
          console.log(`Successfully added the Product to List with lid ${lid}`, addedListItem);
        }

        // Define error callback
        let onError = function (error){
          // Error is an xhrObj
          console.log("Error while adding the Product to the List", error);
        }

        // Call `addToList` with the above callbacks, lid and product object
        swat.addToList(lid, product, onSuccess, onError);
      }
    }
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(onSwymLoadCallback);
    
  },
  fetch: (callbackFn, errorFn) => {},
}







const getOrderSizeTanka = () => {
  return new Promise((resolve) => {
    fetch(
      "//www.unico-fan.co.jp/cdn/shop/files/OrderSizeTanka.csv?v=11492864718056245272",
    )
      .then((response) => response.text())
      .then((text) => {
        const jsonData = csvToJson(text);
        window.OrderSizeTanka = jsonData;
        return resolve(jsonData);
      });
  });
}
const getOrderSizeOptionTanka = () => {
  return new Promise((resolve) => {
    fetch(
      '//www.unico-fan.co.jp/cdn/shop/files/OrderSizeOptionTanka.csv?v=6928815851876730764',
    )
      .then((response) => response.text())
      .then((text) => {
        const jsonData = csvToJson(text);
        window.OrderSizeOptionTanka = jsonData;
        return resolve(jsonData);
      });
  });
}
const getOrderCategory = () => {
  
  return new Promise((resolve) => {
    fetch(
      '//www.unico-fan.co.jp/cdn/shop/files/OrderCategory.csv?v=7727493537379077170',
    )
      .then((response) => response.text())
      .then((text) => {
        const jsonData = csvToJson2(text);
        window.OrderCategory = jsonData;
        return resolve(jsonData);
      });
  });
}
const getOptionShubetu = () => {
  return new Promise((resolve) => {
    fetch(
      '//www.unico-fan.co.jp/cdn/shop/files/OptionShubetu.csv?v=262780490817931260',
    )
      .then((response) => response.text())
      .then((text) => {
        const jsonData = csvToJson2(text);
        window.OptionShubetu = jsonData;
        return resolve(jsonData);
      });
  });
}
// (async () => {
//   if(
//     document.querySelector('wl-order-section') && document.querySelector('wl-order-section').dataset.category != '' ||
//     document.querySelector('wl-order-section') && document.querySelector('wl-order-section').dataset.template == 'cart'
//   ) {
//     window.OrderSizeOptionTanka = await getOrderSizeOptionTanka();
//     window.OrderCategory = await getOrderCategory();
//     window.OptionShubetu = await getOptionShubetu();
//     window.OrderSizeTanka = await getOrderSizeTanka();  
//   } else {
//     window.OrderSizeOptionTanka = []
//     window.OrderCategory = []
//     window.OptionShubetu = []
//     window.OrderSizeTanka = []
//   }
// })()

// 画像スライダー
import 'https://cdn.jsdelivr.net/npm/dayjs@1/dayjs.min.js';
import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';

class WLCollectionProducts extends HTMLElement {
  constructor() {
    super();
    
  }
  connectedCallback() {
    this.sectionId = this.getAttribute('data-section-id');
    this.collectionId = this.getAttribute('data-collection-id');
    this.defaultSortBy = this.getAttribute('data-default-sort-by');
    this.url = this.getAttribute('data-url');
    fetch(`${this.url}?section_id=${this.sectionId}&sort_by=${this.defaultSortBy}`)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        this.innerHTML = doc.querySelector(`[data-section-id="${this.sectionId}"][data-collection-id="${this.collectionId}"]`).innerHTML;
      });
  }
}
customElements.define('wl-collection-products', WLCollectionProducts);

class WLBackInStock extends HTMLElement {
  constructor() {
    super();
    this.modal = document.querySelector('wl-back-in-stock-modal')
    this.addEventListener('click', this.open.bind(this));
  }
  open() {
    this.modal.classList.remove('hidden');
  }
  close() {
    this.querySelector('div[data-modal]').classList.add('hidden');
  }
  submit() {
    const email = this.querySelector('input[type="email"]').value;
    BIS.create(email, this.dataset.variantId, this.dataset.productId).then((res) => {
      alert('入荷通知に登録しました。');
    });
  }
}
customElements.define('wl-back-in-stock', WLBackInStock);
class WLBackInStockModal extends HTMLElement {
  constructor() {
    super();
    this.querySelector('button[data-submit]').addEventListener('click', this.submit.bind(this));
    this.querySelectorAll('[data-close]').forEach(e => {
      e.addEventListener('click', this.close.bind(this));
    })
  }
  close() {
    this.classList.add('hidden');
  }
  submit() {
    const email = this.querySelector('input[type="email"]').value;
    BIS.create(email, this.dataset.variantId, this.dataset.productId).then((res) => {
      alert('入荷通知に登録しました。');

      // the code that you put here will be executed after the user clicks OK in the alert box
      this.close();
    });
  }
}
customElements.define('wl-back-in-stock-modal', WLBackInStockModal);

/**
 * Wishlist Count
 * @class WishlistCount
 * @extends {HTMLElement}
 */
class WishlistCount extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  render() {
    const onSwymLoad = (swat) => {
      if (!swat) return;

      swat.fetchLists({
        callbackFn: (lists) => {
          const currentList = lists.find(list => list.lname === 'unico wishlist');
          if (currentList) {
            this.textContent = currentList.listcontents.length;
            this.classList.remove('hidden');
          } else {
            this.textContent = '0';
          }
        },
        errorFn: (err) => {
          console.error('Error fetching wishlist', err);
        }
      });
    };

    if (window._swat) {
      onSwymLoad(window._swat);
    } else {
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(onSwymLoad);
    }
  }
}

customElements.define('wl-wishlist-count', WishlistCount);


const headerReplace = (str) => {
  const reg = new RegExp(str.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
  const array = [
    { "jp": "オーダーカテゴリコード", "en": "order_category_code" },
    { "jp": "適用開始日", "en": "application_start_date" },
    { "jp": "適用終了日", "en": "application_end_date" },
    { "jp": "オプション1コード", "en": "option1_code" },
    { "jp": "オプション１コード", "en": "option1_code" },
    { "jp": "オブション1コード", "en": "option1_code" },
    { "jp": "オブション１コード", "en": "option1_code" },
    { "jp": "オプション種別コード", "en": "option_type_code" },
    { "jp": "オプションコード", "en": "option_code" },
    { "jp": "単価設定方法フラグ", "en": "unit_price_setting_flag" },
    { "jp": "仕上がり幅(横)", "en": "finish_width_horizontal" },
    { "jp": "仕上がり丈(縦)", "en": "finish_length_vertical" },
    { "jp": "仕上がり幅（横）", "en": "finish_width_horizontal" },
    { "jp": "仕上がり丈（縦）", "en": "finish_length_vertical" },
    { "jp": "売上本体単価", "en": "sales_base_unit_price" },
    { "jp": "売上単価消費税", "en": "sales_unit_price_tax" },
    { "jp": "仕入本体単価", "en": "purchase_base_unit_price" },
    { "jp": "仕入単価消費税", "en": "purchase_unit_price_tax" },
    { "jp": "商品コード", "en": "product_code" },
    { "jp": "オーダーカテゴリ名", "en": "order_category_name" },
    { "jp": "オプション種別1コード", "en": "option_type1_code" },
    { "jp": "オプション種別2コード", "en": "option_type2_code" },
    { "jp": "オプション種別3コード", "en": "option_type3_code" },
    { "jp": "オプション種別4コード", "en": "option_type4_code" },
    { "jp": "オプション種別5コード", "en": "option_type5_code" },
    { "jp": "オプション種別6コード", "en": "option_type6_code" },
    { "jp": "オプション種別7コード", "en": "option_type7_code" },
    { "jp": "オプション種別8コード", "en": "option_type8_code" },
    { "jp": "オプション種別9コード", "en": "option_type9_code" },
    { "jp": "オプション種別10コード", "en": "option_type10_code" },
    { "jp": "入力区分1", "en": "input_type1" },
    { "jp": "入力区分2", "en": "input_type2" },
    { "jp": "入力区分3", "en": "input_type3" },
    { "jp": "入力区分4", "en": "input_type4" },
    { "jp": "入力区分5", "en": "input_type5" },
    { "jp": "入力区分6", "en": "input_type6" },
    { "jp": "入力区分7", "en": "input_type7" },
    { "jp": "入力区分8", "en": "input_type8" },
    { "jp": "入力区分9", "en": "input_type9" },
    { "jp": "入力区分10", "en": "input_type10" },
    { "jp": "レールサイズ入力フラグ", "en": "rail_size_input_flag" },
    { "jp": "オプション名", "en": "option_name" },
    { "jp": "オプション種別名", "en": "option_type_name" },
    { "jp": "変動仕入れ単価", "en": "variable_purchase_price" },
    { "jp": "変動売上単価", "en": "variable_sales_price" }
  ];
  const result = array.find((item) => reg.test(item.jp.trim().replace(/[\r\n\t]/g, '')) || str.trim().replace(/[\r\n\t]/g, '') == item.jp.trim().replace(/[\r\n\t]/g, ''));
  
  if(result) {
    return result.en
  }
  return str;
  
}
/**
 * CSV to JSON
 * @param {String} csv
 * @returns {Object}
 * @example
 **/
const csvToJson = (csv) => {
  const lines = csv.split('\n');
  const result = {};
  const headers = lines[0].split(',');

  for (let i = 1; i < lines.length; i++) {
    const currentline = lines[i].split(',');
    const id = currentline[0];

    if (!result[id]) {
      result[id] = {
        id: id,
        records: [],
      };
    }

    const obj = {};

    for (let j = 1; j < headers.length; j++) {
      obj[headerReplace(headers[j].trim().replace())] = isNaN(currentline[j])
        ? currentline[j]
        : +currentline[j];
    }

    result[id].records.push(obj);
  }

  return result;
};
/**
 * CSV to JSON
 * @param {String} csv
 * @returns {Object}
 * @example
 **/
const csvToJson2 = (csv) => {
  const lines = csv.split('\n');
  const result = [];
  const headers = lines[0].split(',');

  for (let i = 1; i < lines.length; i++) {
    const currentline = lines[i].split(',');
    const id = currentline[0];

    const obj = {};
    for (let j = 0; j < headers.length; j++) {

      if (
        headers[j] == 'オーダーカテゴリ' ||
        headers[j].match(/オプション種別/) ||
        headers[j].match(/オーダーカテゴリーコード/)
      ) {
        obj[headerReplace(headers[j].trim())] = currentline[j];
      } else {
        obj[headerReplace(headers[j].trim())] = isNaN(currentline[j])
          ? currentline[j]
          : +currentline[j];
      }
    }

    result.push(obj);
  }

  return result;
};

/**
 * 最も近い値を見つける関数
 * @param {Array} records
 * @param {Number} width
 * @param {Number} height
 * @param {String} widthKey
 * @param {String} heightKey
 * @param {String} option1Code
 * @returns {Object}
 * @example
 * const records = [
 *  { width: 100, height: 100, option1Code: 1 },
 * { width: 200, height: 200, option1Code: 1 },
 * { width: 300, height: 300, option1Code: 1 },
 * { width: 400, height: 400, option1Code: 1 },
 * { width: 500, height: 500, option1Code: 1 },
 * ];
 * findClosestValue(
 *    this.targetSizeTanka,
 *    width,
 *    height,
 *    '仕上がり幅（横）',
 *    '仕上がり丈（縦）',
 *    this.currentOption.dataset.optionCode,
 *  )
 **/
function findClosestValue(
  records,
  width,
  height,
  widthKey,
  heightKey,
  option1Code,
) {
  // 条件に一致するレコードのみをフィルターする
  if(!records) {
    return null
  }
  const latestItem = records.sort((a, b) => new Date(b['application_start_date'].replaceAll('/', '-')) - new Date(a['application_start_date'].replaceAll('/', '-')));
  
  option1Code = option1Code ? option1Code : 0; 
  const filteredRecords = records.filter(
    (record) =>record[widthKey] >= width &&
      record[heightKey] >= height &&
      record['option1_code'] == option1Code &&
      record['application_start_date'].match(latestItem[0]['application_start_date'])      
  );

  // フィルター後のレコードがない場合、空の配列を返す
  if (filteredRecords.length === 0) {
    return null; // 空の配列よりもnullの方がエラー処理しやすい場合があります
  }

  // 最も近い値を見つけるロジック
  let closestRecord = filteredRecords[0];
  let closestWidthDiff = Math.abs(filteredRecords[0][widthKey] - width);
  let closestHeightDiff = Math.abs(filteredRecords[0][heightKey] - height);

  for (const record of filteredRecords) {
    const widthDiff = Math.abs(record[widthKey] - width);
    const heightDiff = Math.abs(record[heightKey] - height);

    // 幅と丈の差を総合的に評価する
    if (widthDiff < closestWidthDiff && heightDiff < closestHeightDiff) {
      closestWidthDiff = widthDiff;
      closestHeightDiff = heightDiff;
      closestRecord = record;
    }
  }

  // シェード商品（カテゴリー020）の場合は、同じサイズの中で最安値を選択
  // const categoryElement = document.querySelector('wl-order-section');
  // if (categoryElement && categoryElement.dataset.category === '020') {
  //   // 選択されたレコードと同じサイズのレコードをすべて取得
  //   const sameWidthRecords = filteredRecords.filter(record => 
  //     record[widthKey] === closestRecord[widthKey] && 
  //     record[heightKey] === closestRecord[heightKey] &&
  //     record['option1_code'] === closestRecord['option1_code']
  //   );
    
  //   // 同じサイズの中で最安値のレコードを選択
  //   if (sameWidthRecords.length > 1) {
  //     closestRecord = sameWidthRecords.reduce((cheapest, current) => 
  //       current['sales_base_unit_price'] < cheapest['sales_base_unit_price'] ? current : cheapest
  //     );
  //   }
  // }

  return closestRecord;
}

const getSectionRender = (searchParams, sectionId) => {
  return new Promise((resolve, reject) => {
    fetch(location.pathname + '?' + searchParams.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((response) => resolve(response[sectionId]))
      .catch((error) => {
        console.error('Error:', error);
        reject(error);
      })
      .finally(() => {});
  });
};
const sectionRender = (html) => {
  const dom = new DOMParser().parseFromString(html, 'text/html');
  document.querySelector('#wl-product-information').outerHTML =
    dom.querySelector('#wl-product-information').outerHTML;
  document.querySelector(
    '.unico-product-order > form > [name="items[0][id]"]',
  ).value = dom.querySelector(
    '.unico-product-order > form > [name="id"]',
  ).value;
};
class WLNewIcon extends HTMLElement {
  constructor() {
    super();
    this.lead = this.getAttribute('data-lead');
    this.currentDate = dayjs();
    if (this.getAttribute('data-release-date')) {
      this.releaseDate = dayjs(this.getAttribute('data-release-date'));
    } else {
      this.closest('li').style.display = 'none';
    }

    this.futureDate = dayjs(this.releaseDate)
      .add(3, 'month')
    if (this.lead) {
      this.lead = parseInt(this.lead);
    } else {
      this.lead = 3;
    }
    if (this.releaseDate && this.releaseDate != '') {
      this.innerHTML = this.getIcon();
    }
  }
  getIcon() {
    let html = '';
    if (dayjs(this.currentDate).isBefore(this.futureDate)) {
      html += '<span>新着</span>';
    } else if (dayjs(this.currentDate).isAfter(this.futureDate)) {
      this.closest('li').style.display = 'none';
    }

    return html;
  }
}
customElements.define('wl-new-icon', WLNewIcon);

class WLOrderSection extends HTMLElement {
  constructor() {
    super();
    this.matome();
    // 仕上がりサイズ調整済みのサイズを保持するプロパティ
    this.adjustedFinalSize = null; // {width: number, height: number} または null
    // 仕上がりサイズ調整前のサイズを保持するプロパティ（アラート表示用）
    this.originalSizeBeforeAdjustment = null; // {width: number, height: number} または null
    const targetWidthAdjusts = this.querySelectorAll('unico-counter-box[data-width] + .unico-adjust-modal-button');
    targetWidthAdjusts.forEach((targetWidthAdjust) => {
      targetWidthAdjust.addEventListener('click', this.onAdjust.bind(this));
    })
    const targetHeightAdjusts = this.querySelectorAll('unico-counter-box[data-height] + .unico-adjust-modal-button');
    targetHeightAdjusts.forEach((targetHeightAdjust) => {
      targetHeightAdjust.addEventListener('click', this.onAdjust.bind(this));
    })
      
    this.querySelectorAll('button[data-order-select]').forEach((button) => {
      button.addEventListener('click', (e) => {
        const group = button.closest('[role="radiogroup"]');
        if (group) {
          group.querySelectorAll('button[data-order-select]').forEach(btn => {
            btn.setAttribute('aria-checked', 'false');
          });
        }
        button.setAttribute('aria-checked', 'true');
        
        // ヒダタイプ変更時は調整済みサイズをクリア（仕上がりサイズが変わるため）
        if (button.dataset.optionTypeCode === '010') {
          this.adjustedFinalSize = null;
        }
        
        this.matome(e);
        
        if (button.dataset.optionTypeCode === '010') {
          this.varidation(e, false);
        }
      });
    })
    this.querySelectorAll('.unico-order-input-list-content input').forEach((input) => {
      input.addEventListener('change', (e) => {
        // 入力サイズ変更時は調整済みサイズをクリア（再計算が必要）
        this.adjustedFinalSize = null;
        this.matome(e);
      });
    })
    this.querySelectorAll('.unico-order-option-wrapper input').forEach((input) => {
      input.addEventListener('change', this.matome.bind(this));
    })

    document.addEventListener('variant:change', (event) => {
      this.querySelectorAll('button[data-order-select][aria-checked="true"]').forEach(button => {
        button.setAttribute('aria-checked', 'false');
      });
      this.querySelectorAll('unico-radio-button').forEach(group => {
        const firstButton = group.querySelector('button[data-order-select]');
        if (firstButton) {
          firstButton.setAttribute('aria-checked', 'true');
        }
      });
      this.matome();
    });
  }
  async matome(e, changeFinalSize = false, fabricType = 'main') {
    if(!this.OrderCategory || !this.OrderSizeTanka || !this.OrderSizeOptionTanka || !this.OptionShubetu) {
      WLCommon.enableLoading();
      this.OrderCategory = await getOrderCategory();
      this.OrderSizeTanka = await getOrderSizeTanka();
      this.OrderSizeOptionTanka = await getOrderSizeOptionTanka();
      this.OptionShubetu = await getOptionShubetu();
      WLCommon.disableLoading();
    }
    
    
    // this.OrderCategory = await getOrderCategory();
    // this.OrderSizeTanka = await getOrderSizeTanka();
    // this.OrderSizeOptionTanka = await getOrderSizeOptionTanka();
    // this.OptionShubetu = await getOptionShubetu();

    this.priceElm = this.querySelector('.unico-product-price-main');
    this.currentOrderCategory = await this.getOrderCategory();
    if(!this.currentOrderCategory) return
    this.currentOption = await this.getCurrentOption();
    this.targetSizeTanka = await this.getSizeTanka();
    this.size = await this.getSize(changeFinalSize);
    this.setSize(changeFinalSize);
    
    // サイズ調整時は価格データをリセット
    if (changeFinalSize) {
      this.resetOrderPriceData();
    }
    const doubleType = this.querySelector('.unico-product-step-block:has([data-option-type="999"])')
    if(e && doubleType) {
      if (e.target.dataset.optionTypeCode == '020' && (e.target.dataset.optionCode == '2' || e.target.dataset.optionCode == '3')) {
        doubleType.classList.remove('hidden')
        this.querySelector('.unico-order-table[data-sub-item]').classList.remove('hidden')
        this.querySelector('[data-option-type="990"]').closest('.unico-product-step-block').classList.remove('hidden')
        this.querySelector('[data-option-type="990"]').style.opacity = 1;
        this.querySelector('[data-sub-item="true"]').classList.remove('hidden')
        this.querySelector('.unico-order-table[data-sub-size="true"]').classList.remove('hidden')
        this.querySelector('h3[data-sub-size="true"]').classList.remove('hidden')
        doubleType.querySelector('[data-category-code="020"]').setAttribute('aria-checked', true)
        
        // ダブルシェードに切り替えた時に価格表示を更新
      } else if (e.target.dataset.optionTypeCode == '020' && e.target.dataset.optionCode == '1') {
        doubleType.classList.add('hidden')
        this.querySelector('.unico-order-table[data-sub-item]').classList.add('hidden')
        this.querySelector('[data-sub-item="true"]').classList.add('hidden')
        this.querySelector('.unico-order-table[data-sub-size="true"]').classList.add('hidden')
        this.querySelector('h3[data-sub-size="true"]').classList.add('hidden')
        this.querySelector('[data-option-type="990"]').closest('.unico-product-step-block').classList.add('hidden')
        this.querySelector('[data-option-type="990"]').style.opacity = .5;
        doubleType.querySelector('[aria-checked="true"]').removeAttribute('aria-checked')
        this.subOrderCategory = false
        
        // シングルシェードに切り替えた時にサブ生地の価格をリセット
        if (this.priceElm) {
          this.priceElm.dataset.subPrice = '0';
          // 価格表示を更新
          this.setOrderPrice();
        }
      }

      // 選択状況の確認
      /**
       * orderCurrentType: カーテンの種類(シングル/ダブル)
       * orderCurrentOption: カーテンのオプション
       * orderCurrentTypeFlag: カーテンの種類に関するフラグ(ダブルの場合true)
       * doubleTypeOption: ダブルカーテンのオプション
       * doubleTypeSubOption: ダブルカーテンのサブオプション
       * settingPosition: カーテンの設置位置
       */
      const orderCurrentType = this.querySelector('[data-option-type-code="020"][aria-checked="true"]');
      const orderCurrentOption = this.querySelector('[data-option-type-code="011"][aria-checked="true"]');
      const doubleTypeOption = this.querySelector('[data-option-type-code="060"][aria-checked="true"]');
      const doubleTypeSubOption = this.querySelector('[data-option-type="990"]');
      const settingPosition = this.querySelector('unico-radio-button[data-option-type="050"]')
      let orderCurrentTypeFlag = false;
      if(orderCurrentType.dataset.optionCode == '2' || orderCurrentType.dataset.optionCode == '3') {
        orderCurrentTypeFlag = true;
        settingPosition.querySelector('button:last-child').classList.add('hidden')
        if(settingPosition.querySelector('button:last-child').getAttribute('aria-checked') == 'true') {
          settingPosition.querySelector('button[aria-checked="true"]').setAttribute('aria-checked', false)
          settingPosition.querySelector('button').setAttribute('aria-checked', true)
        }
      } else {
        settingPosition.querySelector('button:last-child').classList.remove('hidden')
      }

      if(orderCurrentTypeFlag && orderCurrentOption.dataset.optionCode == '1') {
        doubleTypeSubOption.querySelector(`[aria-checked="true"]`).setAttribute('aria-checked', false)
        doubleTypeSubOption.querySelector(`[data-option-code="${doubleTypeOption.dataset.optionCode}"]`).setAttribute('aria-checked', true)
      } else if(orderCurrentTypeFlag && orderCurrentOption.dataset.optionCode == '2') {
      }

      
      
      
      if(doubleType.querySelector('[aria-checked="true"]')) {
        // サブ生地のサイズを取得（メイン生地と同じサイズ）
        const subSize = this.getSubSize(changeFinalSize);
        
        this.subOrderCategory = this.OrderCategory.find(value => String(value['order_category_code']).toString().padStart(3, '0') == '020');
        this.subOrderOption = doubleType.querySelector('[aria-checked="true"]')
        this.targetSubSizeTanka = this.OrderSizeTanka[doubleType.querySelector('[aria-checked="true"]').dataset.orderId].records.filter((record) => record['option1_code'] == parseInt(this.currentOption.dataset.optionCode))

        // ダブルシェード用のサイズ取得（初期状態では最小サイズを使用）
        const widthInput = this.querySelector('input[name="curtain-width"]');
        const heightInput = this.querySelector('input[name="curtain-height"]');
        let width = parseInt(widthInput.value) || parseInt(widthInput.min) || 100;
        let height = parseInt(heightInput.value) || 100;
        
        // シェード商品の場合、初期状態では最小サイズを使用（最安値表示のため）
        if (this.dataset.category === '020' && !widthInput.value) {
          width = parseInt(widthInput.min) || 30; // シェードの最小幅
        }
        
        const size = this.sendSize(width, height, this.subOption ? this.subOption.dataset.optionCode : 0, true);
        
        this.querySelector('[data-sub-size="true"] [data-target="order-width"]').textContent = width + this.querySelector('[data-target="order-width"]').dataset.unit;
        this.querySelector('[data-sub-size="true"] [data-target="order-height"]').textContent = height + this.querySelector('[data-target="order-width"]').dataset.unit;
        this.querySelector('[data-sub-size="true"] [data-target="order-final-width"]').textContent = size.width + this.querySelector('[data-target="order-width"]').dataset.unit;
        this.querySelector('[data-sub-size="true"] [data-target="order-final-height"]').textContent = size.height + this.querySelector('[data-target="order-width"]').dataset.unit;

        // サブ生地の価格計算 - サブ生地のサイズを使用
        const targetSub = findClosestValue(
          this.targetSubSizeTanka,
          subSize.width,
          subSize.height,
          'finish_width_horizontal',
          'finish_length_vertical',
          this.currentOption ? this.currentOption.dataset.optionCode : 0,
        )
        
        if (targetSub) {
          const addPrice = targetSub['sales_base_unit_price'];
          const addCostPrice = targetSub['purchase_base_unit_price'];
          const subVariants = JSON.parse(doubleType.querySelector('[aria-checked="true"]').dataset.optionProduct)
          const targetVariant = subVariants.find(variant => {
            if(variant.compare_at_price) {
              return variant.compare_at_price == ((Math.trunc(addPrice * 1.1)) * 100)
            } else {
              return variant.price == ((Math.trunc(addPrice * 1.1)) * 100)
            }
          });
          
          this.querySelector('[data-sub-item="true"]').innerHTML = this.subOrderOption.dataset.optionValue;
          if(targetVariant) {
            this.querySelector('h3[data-sub-size="true"]').textContent = targetVariant.name.replaceAll(' - ' + targetVariant.title,'');
            this.querySelector('[data-sub-item-title]').textContent = targetVariant.name.replaceAll(' - ' + targetVariant.title,'');
            this.priceElm.dataset.subPrice = targetVariant.price / 100;
          }
        }
        
      }
    }
    this.setOptionName();
    
    // サイズ調整時はsetTargetVariantsを呼ばずに、直接価格計算を行う
    if (changeFinalSize) {
      if (fabricType === 'main') {
        // メイン生地のサイズ調整の場合
        const mainSize = this.getAdjustedSize('main');
        
        const target = findClosestValue(
          this.targetSizeTanka,
          mainSize.width,
          mainSize.height,
          'finish_width_horizontal',
          'finish_length_vertical',
          this.currentOption ? this.currentOption.dataset.optionCode : 0,
        );
        if (target) {
          const variants = JSON.parse(this.dataset.productVariants);
          const selectedVariant = variants.find(variant => 
            (variant.compare_at_price && variant.compare_at_price != variant.price ? variant.compare_at_price : variant.price ) == ((Math.trunc(target['sales_base_unit_price'] * 1.1)) * 100));
          if (selectedVariant) {
            this.priceElm.dataset.basePrice = selectedVariant.price / 100;
            // フォームのvariant IDも更新
            const form = document.querySelector('[data-target-id="cart-button"]').closest('form');
            if (form) {
              form.querySelector('input[name="items[0][id]"]').value = selectedVariant.id;
            }
          }
        }
        
      } else if (fabricType === 'sub') {
        // サブ生地のサイズ調整の場合
        const subSize = this.getAdjustedSize('sub');
        
        // メイン生地の価格を再計算（メイン生地のサイズを使用）
        const mainSize = this.getMainSize();
        
        const targetMain = findClosestValue(
          this.targetSizeTanka,
          mainSize.width,
          mainSize.height,
          'finish_width_horizontal',
          'finish_length_vertical',
          this.currentOption ? this.currentOption.dataset.optionCode : 0,
        );
        
        if (targetMain) {
          const addPrice = targetMain['sales_base_unit_price'];
          const mainVariants = JSON.parse(this.dataset.productVariants);
          const selectedVariant = mainVariants.find(variant => 
            (variant.compare_at_price && variant.compare_at_price != variant.price ? variant.compare_at_price : variant.price ) == ((Math.trunc(addPrice * 1.1)) * 100));
          if (selectedVariant) {
            this.priceElm.dataset.basePrice = selectedVariant.price / 100;
          }
        }
        
        // サブ生地の価格を再計算
        const doubleType = this.querySelector('.unico-product-step-block:has([data-option-type="999"])');
        if (doubleType && doubleType.querySelector('[aria-checked="true"]')) {
          this.subOrderCategory = this.OrderCategory.find(value => String(value['order_category_code']).toString().padStart(3, '0') == '020');
          
          // サブ生地のオプションコードを取得（メイン生地とは異なる可能性がある）
          const subOptionCode = doubleType.querySelector('[aria-checked="true"]').dataset.optionCode || this.currentOption?.dataset.optionCode || 0;
          
          this.targetSubSizeTanka = this.OrderSizeTanka[doubleType.querySelector('[aria-checked="true"]').dataset.orderId].records.filter((record) => record['option1_code'] == parseInt(subOptionCode));
          
          const targetSub = findClosestValue(
            this.targetSubSizeTanka,
            subSize.width,
            subSize.height,
            'finish_width_horizontal',
            'finish_length_vertical',
            subOptionCode,
          );
          
          if (targetSub) {
            const addPrice = targetSub['sales_base_unit_price'];
            const subVariants = JSON.parse(doubleType.querySelector('[aria-checked="true"]').dataset.optionProduct);
            const targetVariant = subVariants.find(variant => {
              if(variant.compare_at_price) {
                return variant.compare_at_price == ((Math.trunc(addPrice * 1.1)) * 100);
              } else {
                return variant.price == ((Math.trunc(addPrice * 1.1)) * 100);
              }
            });
            
            if(targetVariant) {
              this.priceElm.dataset.subPrice = targetVariant.price / 100;
            }
          }
        }
      }
    }
    
    // サイズ調整時以外はsetTargetVariantsを呼ぶ
    if (!changeFinalSize) {
      await this.setTargetVariants();
    }
    
    this.OrderSizeOptionTanka = await this.getOrderSizeOptionTanka();
    await this.setSubPriceOptions();
    
    // ダブルシェードの場合、サブ生地の価格を設定
    if (!changeFinalSize) {
      const doubleType = this.querySelector('.unico-product-step-block:has([data-option-type="999"])');
      if (doubleType && doubleType.querySelector('[aria-checked="true"]')) {
        this.subOrderCategory = this.OrderCategory.find(value => String(value['order_category_code']).toString().padStart(3, '0') == '020');
        this.targetSubSizeTanka = this.OrderSizeTanka[doubleType.querySelector('[aria-checked="true"]').dataset.orderId].records.filter((record) => record['option1_code'] == parseInt(this.currentOption.dataset.optionCode));
        
        const targetSub = findClosestValue(
          this.targetSubSizeTanka,
          this.size.width,
          this.size.height,
          'finish_width_horizontal',
          'finish_length_vertical',
          this.currentOption ? this.currentOption.dataset.optionCode : 0,
        );
        
        if (targetSub) {
          const addPrice = targetSub['sales_base_unit_price'];
          const subVariants = JSON.parse(doubleType.querySelector('[aria-checked="true"]').dataset.optionProduct);
          const targetVariant = subVariants.find(variant => {
            if(variant.compare_at_price) {
              return variant.compare_at_price == ((Math.trunc(addPrice * 1.1)) * 100);
            } else {
              return variant.price == ((Math.trunc(addPrice * 1.1)) * 100);
            }
          });
          
          if(targetVariant) {
            this.priceElm.dataset.subPrice = targetVariant.price / 100;
          }
        }
      }
    }
    
    // サイズ調整時は、価格表示を最後に実行
    this.setOrderPrice();
    
    // エラーハンドリングを追加
    try {
      if(e) {
        await this.varidation(e, changeFinalSize);
      } else if(changeFinalSize) {
        // サイズ調整時は、排他制御を実行するためにvaridationを呼び出し
        await this.varidation(null, changeFinalSize);
      }
    } catch (error) {
      console.error('Error in matome function:', error);
      // エラーが発生しても排他制御は実行する
      if(e || changeFinalSize) {
        await this.varidation(e, changeFinalSize);
      }
    }
    
    // サブ生地サイズ調整時は、メイン生地の価格計算でメイン生地のサイズを使用
    if (fabricType === 'sub' && changeFinalSize) {
      const mainSize = this.getMainSize();
      // メイン生地の価格を再計算（メイン生地のサイズを使用）
      this.calculateMainPrice(mainSize);
    }
    
    // ページ読み込み時の初期状態もヒダタイプに応じて設定
    if(!e) {
      this.setInitialOptionStates();
    }
    // イベントがある場合は、既存の排他制御の状態を維持（何もしない）
  }
  async getOrderCategory() {
    
    this.currentOrderCategory = this.OrderCategory.find(value => String(value['order_category_code']).toString().padStart(3, '0') == this.dataset.category);
    return this.currentOrderCategory
  }
  async getCurrentOption() {
    this.currentOption = this.querySelector(`button[aria-checked="true"][data-option-type-code="${this.currentOrderCategory['option_type1_code']}"]`)
    if(!this.currentOption) return
    this.querySelector(`.unico-order-table [data-option="${this.currentOption.dataset.optionName}"]`).innerHTML = this.currentOption.dataset.optionValue;
    return this.currentOption
  }
  async getSizeTanka() {
    this.currentOption = await this.getCurrentOption();
    if(!this.currentOption) {
      this.targetSizeTanka = this.OrderSizeTanka[this.dataset.orderId].records
      return this.targetSizeTanka
    }
    this.targetSizeTanka = this.OrderSizeTanka[this.dataset.orderId].records.filter((record) => record['option1_code'] == parseInt(this.currentOption.dataset.optionCode))
    
    return this.targetSizeTanka
  }
  getSize(changeFinalSize = false) {
    // 調整済みサイズがある場合は、それを優先的に使用
    if (this.adjustedFinalSize && !changeFinalSize) {
      return { ...this.adjustedFinalSize };
    }
    
    let width = 100;
    const widthInput = this.querySelector('input[name="curtain-width"]');
    const inputValue = parseInt(widthInput.value);
    const minValue = parseInt(widthInput.min);
    
    // 入力値がある場合はそれを使用、なければmin属性、それもなければ100をフォールバック
    width = inputValue || minValue || 100;
    
    // シェード商品の場合、初期状態では最小サイズを使用（最安値表示のため）
    if (this.dataset.category === '020' && !inputValue) {
      width = minValue || 30; // シェードの最小幅（30cmなど、実際の最小値に調整）
    }
    
    // heightは従来通りの処理を維持
    const height = parseInt(this.querySelector('input[name="curtain-height"]').value) || 100;
    const targetWidth = this.querySelector('unico-counter-box[data-width] .value');
    const targetHeight = this.querySelector('unico-counter-box[data-height] .value');
    const size = this.sendSize(width, height, this.currentOption ? this.currentOption.dataset.optionCode : 0);
    if(changeFinalSize == true) {
      size.width = parseInt(targetWidth.textContent);
      size.height = parseInt(targetHeight.textContent);
      // 調整済みサイズを保存
      this.adjustedFinalSize = { width: size.width, height: size.height };
    }
    return size
  }
  setSize(changeFinalSize = false) {
    this.size = this.getSize(changeFinalSize);
    
    const widthInput = this.querySelector('input[name="curtain-width"]');
    let width = parseInt(widthInput.value) || parseInt(widthInput.min) || 100;
    
    // シェード商品の場合、初期状態では最小サイズを使用（最安値表示のため）
    if (this.dataset.category === '020' && !widthInput.value) {
      width = parseInt(widthInput.min) || 30; // シェードの最小幅
    }
    
    // heightは従来通りの処理を維持
    const height = parseInt(this.querySelector('input[name="curtain-height"]').value) || 100;
    const targetWidth = this.querySelector('unico-counter-box[data-width] .value');
    const targetHeight = this.querySelector('unico-counter-box[data-height] .value');
    const targetWidthAdjust = this.querySelector('unico-counter-box[data-width] + .unico-adjust-modal-button');
    const targetHeightAdjust = this.querySelector('unico-counter-box[data-height] + .unico-adjust-modal-button');
    if(changeFinalSize == false) {
      targetWidthAdjust.dataset.value = this.size.width;
      targetHeightAdjust.dataset.value = this.size.height;
      this.querySelector('[data-target="order-width"]').textContent = width + this.querySelector('[data-target="order-width"]').dataset.unit;
      this.querySelector('[data-target="order-height"]').textContent = height + this.querySelector('[data-target="order-width"]').dataset.unit;
      this.querySelector('[data-target="order-final-width"]').textContent = this.size.width + this.querySelector('[data-target="order-width"]').dataset.unit;
      this.querySelector('[data-target="order-final-height"]').textContent = this.size.height + this.querySelector('[data-target="order-width"]').dataset.unit;
    } else {
      targetWidthAdjust.dataset.value = targetWidth.textContent
      targetHeightAdjust.dataset.value = targetHeight.textContent
      this.size.width = parseInt(targetWidth.textContent);
      this.size.height = parseInt(targetHeight.textContent);
    }

    this.changePreviewImage(this.querySelector('[data-preview-type][aria-checked="true"]'))
    if(this.querySelector('.unico-order-preview').dataset.previewType == 'single') {
      this.querySelector('[data-preview-num="width1"]').textContent = this.size.width;
      this.querySelector('[data-preview-num="height"]').textContent = this.size.height;
    } else {
      this.querySelector('[data-preview-num="width1"]').textContent = this.size.width / 2;
      this.querySelector('[data-preview-num="width2"]').textContent = this.size.width / 2;
      this.querySelector('[data-preview-num="height"]').textContent = this.size.height;
    }
    
  }
  setOptionName() {
    const list = this.querySelectorAll(`button[aria-checked="true"]`)
    for(let elm of list){
      const radioButton = elm.closest('unico-radio-button');
      
      // レース商品（カテゴリ012）の場合は特別な処理
      if (this.dataset.category === '012') {
        const options = this.querySelectorAll(`.unico-order-table [data-option="${elm.dataset.optionName}"]`)
        for(let option of options) {
          option.innerHTML = elm.dataset.optionValue;
        }
        continue;
      }
      
      // null チェックを追加
      if (!radioButton) {
        console.warn('unico-radio-button not found for element:', elm);
        continue;
      }
      
      if(radioButton.getAttribute('data-option-type') == '060') {
        const targetElement = this.querySelector(`.table[data-sub-item="false"] + table [data-option="${elm.dataset.optionName}"]`);
        if (targetElement) {
          targetElement.innerHTML = elm.dataset.optionValue;
        }
      } else if (radioButton.getAttribute('data-option-type') == '990') {
        const targetElement = this.querySelector(`.table[data-sub-item="true"] + table [data-option="${elm.dataset.optionName}"]`);
        if (targetElement) {
          targetElement.innerHTML = elm.dataset.optionValue;
        }
      } else {
        const options = this.querySelectorAll(`.unico-order-table [data-option="${elm.dataset.optionName}"]`)
        for(let option of options) {
          option.innerHTML = elm.dataset.optionValue;
        }
      }
    }
  }
  
  resetOrderPriceData() {  
    if (this.priceElm) {
      this.priceElm.dataset.optionPrice = '0';
      this.priceElm.dataset.basePrice = '';
      this.priceElm.dataset.comparaAtPrice = '';
      this.priceElm.dataset.subPrice = '';
    }
  }
  async getOrderSizeOptionTanka() {
    return this.OrderSizeOptionTanka
  }
  async setSubPriceOptions() {
    this.subPriceOptions = this.querySelectorAll('.unico-order-option-wrapper input:checked')
    const optionsTable = this.querySelector('.unico-order-table [data-options]')
    if(!optionsTable) return
    optionsTable.innerHTML = '';
    
    // オプション価格をリセット
    if (this.priceElm) {
      this.priceElm.dataset.optionPrice = '0';
    }
    
    // サブ生地サイズ調整時は、メイン生地のサイズを使用
    const sizeToUse = this.getMainSize() || this.size;
    
    for(let subPriceOption of this.subPriceOptions) {
      let addPrice = 0;
      let addCostPrice = 0
      const productData = subPriceOption.dataset.targetProduct;
      const json = JSON.parse(productData);
      let variants = json.variants;

      optionsTable.innerHTML += `<li>${subPriceOption.dataset.name}</li>`

      const subPriceOptionTanka = this.OrderSizeOptionTanka[this.dataset.category].records.filter(s => {
        return s['option_code'] == parseInt(subPriceOption.value) && s['option_type_code'] == parseInt(subPriceOption.dataset.optionTypeCode)
      })
      this.latestItem = subPriceOptionTanka.sort((a, b) => new Date(b['application_start_date'].replaceAll('/', '-')) - new Date(a['application_start_date'].replaceAll('/', '-')));
      const filteredRecords = subPriceOptionTanka.filter(
        (record) =>
          record["finish_width_horizontal"] >= sizeToUse.width &&
          record["finish_length_vertical"] >= sizeToUse.height && 
          record["option1_code"] == parseInt(this.currentOption.dataset.optionCode) &&
          record["application_start_date"].match(this.latestItem[0]["application_start_date"])
      );
      if(subPriceOptionTanka.length > 0) {
        const closestRecord = this.getSubPriceOptionTanka1(filteredRecords, sizeToUse)
        if (!closestRecord) continue
        addPrice = closestRecord['sales_base_unit_price'];
        addCostPrice = closestRecord['purchase_base_unit_price'];
      } else {
        const targetOption = await this.getSubPriceOptionTanka2(subPriceOption)
        if (!targetOption) continue
        addPrice = targetOption['variable_sales_price'];
        addCostPrice = targetOption['variable_purchase_price'];
      }
      
      subPriceOption.dataset.targetPrice = addPrice;
      subPriceOption.dataset.targetCostPrice = addCostPrice;
      
      if(subPriceOption.dataset.discountPercent) {
        variants = variants.filter(variant => variant.option2 == subPriceOption.dataset.discountPercent)
      } else {
        variants = variants.filter(variant => variant.option2 == '0%')
      }
      const targetVariant = variants.find(variant => variant.compare_at_price == ((Math.trunc(addPrice * 1.1)) * 100));
      if(addPrice > 0) {
        subPriceOption.dataset.variantId = targetVariant.id;
        this.priceElm.dataset.optionPrice = 
          parseInt(this.priceElm.dataset.optionPrice) + targetVariant.price / 100;
      }
    }
  }
  getSubPriceOptionTanka1(filteredRecords, sizeToUse) {
    let widthKey = 'finish_width_horizontal';
    let heightKey = 'finish_length_vertical';
    let closestRecord = filteredRecords[0];
    if (!filteredRecords[0] || !sizeToUse) {
      return null;
    }

    let closestWidthDiff = Math.abs(filteredRecords[0][widthKey] - sizeToUse.width);
    let closestHeightDiff = Math.abs(filteredRecords[0][heightKey] - sizeToUse.height);

    for (const record of filteredRecords) {
      const widthDiff = Math.abs(record[widthKey] - sizeToUse.width);
      const heightDiff = Math.abs(record[heightKey] - sizeToUse.height);

      // 幅と丈の差を総合的に評価する
      if (widthDiff < closestWidthDiff && heightDiff < closestHeightDiff) {
        closestWidthDiff = widthDiff;
        closestHeightDiff = heightDiff;
        closestRecord = record;
      }
    }
    return closestRecord
  }
  async getSubPriceOptionTanka2(subPriceOption) {
    const targetOption = this.OptionShubetu.find(record => 
      record['option_type_code'] == parseInt(subPriceOption.dataset.optionTypeCode) &&
      record['option_code'] == parseInt(subPriceOption.value)
    )
    return targetOption
  }
  
  // メイン生地の価格計算を独立して行うメソッド
  calculateMainPrice(mainSize) {
    if (!mainSize || !this.currentOption) return;
    
    const targetMain = findClosestValue(
      this.targetSizeTanka,
      mainSize.width,
      mainSize.height,
      'finish_width_horizontal',
      'finish_length_vertical',
      this.currentOption.dataset.optionCode,
    );
    
    if (targetMain) {
      const addPrice = targetMain['sales_base_unit_price'];
      const mainVariants = JSON.parse(this.currentOption.dataset.optionProduct);
      const targetVariant = mainVariants.find(variant => {
        if(variant.compare_at_price) {
          return variant.compare_at_price == ((Math.trunc(addPrice * 1.1)) * 100);
        } else {
          return variant.price == ((Math.trunc(addPrice * 1.1)) * 100);
        }
      });
      
      if(targetVariant) {
        this.priceElm.dataset.basePrice = targetVariant.price / 100;
        // 価格表示を更新
        this.setOrderPrice();
      }
    }
  }
  setOrderPrice() {
    this.priceElm = this.querySelector('.unico-product-price-main');
    const comparaPrice = this.priceElm.dataset.comparaAtPrice ? parseInt(this.priceElm.dataset.comparaAtPrice) : 0;
    const optionPrice = this.priceElm.dataset.optionPrice ? parseInt(this.priceElm.dataset.optionPrice) : 0;
    
    // basePriceの計算を修正
    let basePrice = 0;
    if (this.priceElm.dataset.basePrice) {
      basePrice = parseInt(this.priceElm.dataset.basePrice);
    } else {
      // targetが未定義の場合の処理を追加
      const target = this.getCurrentTarget();
      if (target) {
        basePrice = Math.trunc(target['sales_base_unit_price'] * 1.1);
      }
    }
    
    const subPrice = this.priceElm.dataset.subPrice ? parseInt(this.priceElm.dataset.subPrice) : 0;
    
    // 合計金額の計算
    const totalPrice = basePrice + optionPrice + subPrice;
    
    if(basePrice !== comparaPrice && comparaPrice !== 0) {
      this.priceElm.innerHTML = `
      <s style="font-size: 16px;">¥${comparaPrice.toLocaleString()}(税込)</s> <span style="color:var(--unico-color-important);">¥${totalPrice.toLocaleString()}</span>
      `
    } else {
      this.priceElm.textContent = '¥' + totalPrice.toLocaleString();
    }
  }
  
  // 価格データをリセットするメソッド
  resetOrderPriceData() {
    if (this.priceElm) {
      this.priceElm.dataset.basePrice = '';
      this.priceElm.dataset.subPrice = '';
      this.priceElm.dataset.optionPrice = '0';
    }
  }
  
  // 現在のターゲットを取得するメソッド
  getCurrentTarget() {
    // 現在の選択状態に基づいて適切なターゲットを返す
    if (this.targetSizeTanka && this.size) {
      return findClosestValue(
        this.targetSizeTanka,
        this.size.width,
        this.size.height,
        'finish_width_horizontal',
        'finish_length_vertical',
        this.currentOption ? this.currentOption.dataset.optionCode : 0,
      );
    }
    return null;
  }
  
  // メイン生地のサイズを取得するメソッド
  getMainSize(changeFinalSize = false) {
    // メイン生地のサイズ調整モーダルからサイズを取得
    const mainModal = this.querySelector('.unico-adjust-modal[data-fabric-type="main"]');
    if (mainModal) {
      const targetWidth = mainModal.querySelector('unico-counter-box[data-width] .value');
      const targetHeight = mainModal.querySelector('unico-counter-box[data-height] .value');
      if (targetWidth && targetHeight) {
        const width = parseInt(targetWidth.textContent);
        const height = parseInt(targetHeight.textContent);
        // デフォルト値（100x100）の場合は、入力フィールドからサイズを取得
        if (width === 100 && height === 100) {
          const widthInput = this.querySelector('input[name="curtain-width"]');
          const heightInput = this.querySelector('input[name="curtain-height"]');
          const inputWidth = parseInt(widthInput.value) || parseInt(widthInput.min) || 100;
          const inputHeight = parseInt(heightInput.value) || 100;
          
          return this.sendSize(inputWidth, inputHeight, this.currentOption ? this.currentOption.dataset.optionCode : 0);
        }
        
        if (width > 0 && height > 0) {
          return {
            width: width,
            height: height
          };
        }
      }
    }
    
    // モーダルが見つからない場合や、有効なサイズが取得できない場合は、入力フィールドからサイズを取得
    const widthInput = this.querySelector('input[name="curtain-width"]');
    const heightInput = this.querySelector('input[name="curtain-height"]');
    const width = parseInt(widthInput.value) || parseInt(widthInput.min) || 100;
    const height = parseInt(heightInput.value) || 100;
    
    return this.sendSize(width, height, this.currentOption ? this.currentOption.dataset.optionCode : 0);
  }
  
  // サブ生地のサイズを取得するメソッド
  getSubSize(changeFinalSize = false) {
    // サブ生地はメイン生地と同じサイズを使用
    return this.getSize(changeFinalSize);
  }
  
  // サイズ調整時のサイズを取得するメソッド（メイン生地とサブ生地で独立）
  getAdjustedSize(fabricType = 'main') {
    // 指定された生地タイプのモーダルからサイズを取得
    const modal = this.querySelector(`.unico-adjust-modal[data-fabric-type="${fabricType}"]`);
    if (modal) {
      const targetWidth = modal.querySelector('unico-counter-box[data-width] .value');
      const targetHeight = modal.querySelector('unico-counter-box[data-height] .value');
      if (targetWidth && targetHeight) {
        return {
          width: parseInt(targetWidth.textContent),
          height: parseInt(targetHeight.textContent)
        };
      }
    }
    
    // モーダルが見つからない場合や、サイズが取得できない場合は、現在のサイズを返す
    const currentSize = this.getSize();
    return currentSize;
  }
  
  /**
   * 開き方制御の共通メソッド
   * @param {Object} size - 制御に使用するサイズ情報 {width: number, height: number}
   * @param {boolean} forceUpdate - 強制的に制御を実行するかどうか
   */
  setOpeningTypeControl(size, forceUpdate = false, showAlert = false) {
    // 開き方オプションが存在しない場合は処理を終了
    const openingTypeOptions = this.querySelector('[data-option-type-code="030"]');
    if (!openingTypeOptions) {
      return;
    }
    
    const bothOpenButton = this.querySelector('[data-option-type-code="030"][data-option-code="1"]'); // 両開き
    const singleOpenButton = this.querySelector('[data-option-type-code="030"][data-option-code="2"]'); // 片開き
    
    if (!bothOpenButton || !singleOpenButton) {
      return;
    }
    
    // ヒダの種類を取得
    const straightHida = this.querySelector('[data-option-type-code="010"][data-option-code="3"][aria-checked="true"]'); // ストレート
    const isStraight = !!straightHida;
    
    let shouldDisableBothOpen = false;
    
    if (isStraight) {
      // ストレートヒダの場合：仕上がりサイズ141cm未満は両開き無効
      shouldDisableBothOpen = size.width < 141;
    } else {
      // 1.5倍ヒダ・2倍ヒダの場合：仕上がりサイズ101cm未満は両開き無効
      shouldDisableBothOpen = size.width < 101;
    }
    
    if (shouldDisableBothOpen) {
      // 両開きを無効化
      bothOpenButton.disabled = true;
      bothOpenButton.setAttribute('aria-checked', 'false');
      
      const bothOpenWrapper = bothOpenButton.closest('.unico-product-step-block');
      if (bothOpenWrapper) {
        bothOpenWrapper.style.opacity = 0.5;
      }
      
      // 片開きを有効化・選択
      singleOpenButton.disabled = false;
      singleOpenButton.setAttribute('aria-checked', 'true');
      const singleOpenWrapper = singleOpenButton.closest('.unico-product-step-block');
      if (singleOpenWrapper) {
        singleOpenWrapper.style.opacity = 1;
      }
      
      // 完成イメージとその他の項目を更新
      this.changePreviewImage(singleOpenButton);
      this.setOptionName();
    } else {
      // 両開きを有効化
      bothOpenButton.disabled = false;
      const bothOpenWrapper = bothOpenButton.closest('.unico-product-step-block');
      if (bothOpenWrapper) {
        bothOpenWrapper.style.opacity = 1;
      }
      
      // 現在の選択状態を維持（強制更新でない場合）
      if (!forceUpdate) {
        return;
      }
      
      // 強制更新の場合は、現在の選択状態を確認
      const currentSelection = this.querySelector('[data-option-type-code="030"][aria-checked="true"]');
      if (!currentSelection) {
        // 何も選択されていない場合は片開きをデフォルト選択
        singleOpenButton.setAttribute('aria-checked', 'true');
      }
    }
  }
  
  setInitialOptionStates() {
    // ページ読み込み時の初期状態をヒダタイプに応じて設定
    if(this.dataset.category == '010' || this.dataset.category == '011' || this.dataset.category == '012' || this.dataset.category == '013' || this.dataset.category == '014') {
      const target = this.querySelector('[data-option-type-code="110"]') // 形態安定加工
      const chainWeightTarget = this.querySelector('[data-option-type-code="150"]') // チェーンウェイト加工
      
      if(target && chainWeightTarget) { 
        if(this.querySelector('[data-option-type-code="010"][data-option-code="3"][aria-checked="true"]')) { // ストレート
          // ストレートヒダが選択されている場合：形態安定加工はopacity0.5にして無効化
          target.disabled = true
          target.checked = false
          target.closest('.unico-order-option-wrapper').style.opacity = 0.5
          
          // チェーンウェイト加工は有効化
          chainWeightTarget.disabled = false
          chainWeightTarget.closest('.unico-order-option-wrapper').style.opacity = 1
          
        } else { // 1.5倍ヒダ or 2倍ヒダ
          // 1.5倍ヒダか2倍ヒダが選択されている場合：排他制御の状態を考慮して有効化
          target.disabled = false
          target.closest('.unico-order-option-wrapper').style.opacity = 1
          
          chainWeightTarget.disabled = false
          chainWeightTarget.closest('.unico-order-option-wrapper').style.opacity = 1
          
          // 排他制御の状態を確認し、必要に応じて適用
          this.applyExclusiveControlIfNeeded();
        }
      }
    }
    
    // 【修正】ページロード時の開き方制御を共通メソッドに置き換え
    const size = this.getSize();
    this.setOpeningTypeControl(size, true); // 初期化時は強制更新
  }
  setTargetVariants() {
    const target = findClosestValue(
      this.targetSizeTanka,
      this.size.width,
      this.size.height,
      'finish_width_horizontal',
      'finish_length_vertical',
      this.currentOption ? this.currentOption.dataset.optionCode : 0,
    )
    let comparaPrice = 0;
    if(target) { 
      const variants = JSON.parse(this.dataset.productVariants)
      const selectedVariant = variants.find(variant => 
          (variant.compare_at_price && variant.compare_at_price != variant.price ? variant.compare_at_price : variant.price ) == ((Math.trunc(target['sales_base_unit_price'] * 1.1)) * 100));
      const form = document.querySelector('[data-target-id="cart-button"]').closest('form');
      if(selectedVariant) {
        form.querySelector('input[name="items[0][id]"]').value = selectedVariant.id;
        comparaPrice = selectedVariant?.compare_at_price ? selectedVariant?.compare_at_price / 100 : 0;

        this.priceElm.dataset.basePrice = selectedVariant.price / 100;
        this.priceElm.dataset.costPrice = target['purchase_base_unit_price'];
        this.priceElm.dataset.comparaAtPrice = comparaPrice
      }
    }
  }
  
  connectedCallback() {
    
    
  }
  
  onAdjust(e) {
    const target = e.target.closest('.unico-adjust-modal-row').querySelector('.value');
    const targetAdjust = e.target.dataset.value;
    target.textContent = targetAdjust;
  }
  /**
   * // オプションボタンクリック時の処理 
   * @param {*} e
   **/

  changePreviewImage(elm) {
    if(!elm) {
      return
    }
    this.querySelector('.unico-order-preview img').setAttribute('src', elm.dataset.previewImage);
    this.querySelector('.unico-order-preview').dataset.previewType = elm.dataset.previewType;
    const target = this.querySelector('[data-option-type-code="040"][value="3"]')
    const target2 = this.querySelector('[data-option-type-code="040"][value="2"]')
    this.singlePreview = elm.dataset.previewType == 'single' ? true : false;
    if(this.singlePreview) {
      target.closest('label').classList.add('hidden')
      target.checked = false
      target.disabled = true
      target2.closest('label').classList.remove('hidden')
      target2.disabled = false
      if(target.checked) { 
        target2.checked = true
      }
    } else {
      target.closest('label').classList.remove('hidden')
      target.disabled = false
      target2.closest('label').classList.add('hidden')
      target2.checked = false
      target2.disabled = true
      if(target2.checked) { 
        target.checked = true
      }
    }
  }

  varidation(e, changeFinalSize = false) {
    const addToButton = this.querySelector('.unico-product-order-block button')
    addToButton.removeAttribute('disabled')
    addToButton.style.opacity = 1
    const size = this.getSize(changeFinalSize);
    if(this.dataset.category == '010' || this.dataset.category == '011' || this.dataset.category == '012' || this.dataset.category == '013' || this.dataset.category == '014') {
      const target = this.querySelector('[data-option-type-code="110"]') // 形態安定加工
      const chainWeightTarget = this.querySelector('[data-option-type-code="150"]') // チェーンウェイト加工
    
      if(target && chainWeightTarget) { 
        if(this.querySelector('[data-option-type-code="010"][data-option-code="3"][aria-checked="true"]')) { // ストレート
          // ストレートヒダが選択されたら、形態安定加工はopacity0.5にして無効化
          target.disabled = true
          target.checked = false
          target.closest('.unico-order-option-wrapper').style.opacity = 0.5
          
          // チェーンウェイト加工は有効化
          chainWeightTarget.disabled = false
          chainWeightTarget.closest('.unico-order-option-wrapper').style.opacity = 1
          
        } else { // 1.5倍ヒダ or 2倍ヒダ
          // 1.5倍ヒダか2倍ヒダが選択されたら、排他制御の状態を考慮して有効化
          target.disabled = false
          target.closest('.unico-order-option-wrapper').style.opacity = 1
          
          chainWeightTarget.disabled = false
          chainWeightTarget.closest('.unico-order-option-wrapper').style.opacity = 1
          
          // 排他制御の状態を確認し、必要に応じて適用
          this.applyExclusiveControlIfNeeded();
        }
      }
    }
    const formStabilizing = this.querySelector('[data-option-type-code="110"]') // 形態安定加工のチェックボックス
    if(formStabilizing) {
      const formStabilizingWrapper = formStabilizing.closest('.unico-order-option-wrapper')
      
      if(size.width > 400) { //入力値でいうと390cm以上
        formStabilizing.disabled = true
        formStabilizing.checked = false
        formStabilizingWrapper.querySelector('.unico-order-option-image').style.opacity = 0.5
        formStabilizingWrapper.querySelector('.unico-checkbox').style.opacity = 0.5
        
      } else {
        if(this.querySelector('[data-option-type-code="010"][data-option-code="3"][aria-checked="true"]')) {
          formStabilizing.disabled = true
          formStabilizing.checked = false
          formStabilizingWrapper.querySelector('.unico-order-option-image').style.opacity = 0.5
          formStabilizingWrapper.querySelector('.unico-checkbox').style.opacity = .5
        } else {
          formStabilizing.disabled = false
          formStabilizingWrapper.querySelector('.unico-order-option-image').style.opacity = 1
          formStabilizingWrapper.querySelector('.unico-checkbox').style.opacity = 1 
        }
      }
    }

    if(size.width > parseInt(this.querySelector('input[name="curtain-width"]').max)) {
      alert('最大値を超えています');
      addToButton.setAttribute('disabled', 'true')
      addToButton.style.opacity = .5
      return
    } 
    if(size.height > parseInt(this.querySelector('input[name="curtain-height"]').max)) {
      alert('最大値を超えています');
      addToButton.setAttribute('disabled', 'true')
      addToButton.style.opacity = .5
      return
    } 
    if(size.width < parseInt(this.querySelector('input[name="curtain-width"]').min)) {
      alert('最小値を下回っています');
      addToButton.setAttribute('disabled', 'true')
      addToButton.style.opacity = .5
      return
    } 
    if(size.height < parseInt(this.querySelector('input[name="curtain-height"]').min)) {
      alert('最小値を下回っています');
      addToButton.setAttribute('disabled', 'true')
      addToButton.style.opacity = .5
      return
    }

    if(
      size.width < 40 && size.height > 200 && 
      this.dataset.category == '020' && 
      this.querySelector('[data-option-type-code="011"]') && 
      this.querySelector('[data-option-type-code="011"][data-option-type-code="011"]') &&
      this.querySelector('[data-option-type-code="011"][data-option-code="1"][aria-checked="true"]')
    ) {
      alert('注文できないサイズです。');
      addToButton.setAttribute('disabled', 'true')
      addToButton.style.opacity = .5
    } else if(
      size.width < 67 && size.height > 300 &&
      this.dataset.category == '020' &&
      this.querySelector('[data-option-type-code="011"]') &&
      this.querySelector('[data-option-type-code="011"][data-option-type-code="011"]') &&
      this.querySelector('[data-option-type-code="011"][data-option-code="1"][aria-checked="true"]')
    ) {
      alert('注文できないサイズです。');
      addToButton.setAttribute('disabled', 'true')
      addToButton.style.opacity = .5
    } else if(
      size.width < 400 && size.height > 400 &&
      this.dataset.category == '020' &&
      this.querySelector('[data-option-type-code="011"]') &&
      this.querySelector('[data-option-type-code="011"][data-option-type-code="011"]') &&
      this.querySelector('[data-option-type-code="011"][data-option-code="1"][aria-checked="true"]')
    ) {
      alert('注文できないサイズです。');
      addToButton.setAttribute('disabled', 'true')
      addToButton.style.opacity = .5
    } else if(
      size.height < 48 && 
      this.dataset.category == '020'
    ) {
      alert('注文できないサイズです。');
      addToButton.setAttribute('disabled', 'true')
      addToButton.style.opacity = .5
    }

    // 【修正】開き方制御を共通メソッドに置き換え
    // 仕上がりサイズ調整時（changeFinalSize=true）は、script-product-detail.jsで制御が行われるためスキップ
    if (!changeFinalSize) {
      this.setOpeningTypeControl(size);
    }
    
    if(this.querySelector('[data-option-type="010"]')) {
      if(size.width > 400 && this.querySelector('[data-option-type-code="010"][data-option-code="1"][aria-checked="true"]')) {
        alert('注文できないサイズです。');
        addToButton.setAttribute('disabled', 'true')
        addToButton.style.opacity = .5
        return
      } else if(size.width > 400 && this.querySelector('[data-option-type-code="010"][data-option-code="2"][aria-checked="true"]')) {
        alert('注文できないサイズです。');
        addToButton.setAttribute('disabled', 'true')
        addToButton.style.opacity = .5
        return
      }
    }
    if(e && e.target.dataset.optionTypeCode == '120') {
      if(e.target.value == '1') {
        this.querySelector('[data-option-type-code="120"][value="2"]').checked = false;
      } else if(e.target.value == '2') {
        this.querySelector('[data-option-type-code="120"][value="1"]').checked = false;
      }
      
      // 遮光裏地オプション切り替え時の価格再計算
      this.setSubPriceOptions().then(() => {
        this.setOrderPrice();
      });
    }
        // 形態安定加工とチェーンウェイト加工の排他制御
    if(e && e.target.dataset.optionTypeCode == '150') {
      // チェーンウェイト加工の選択/解除時の処理
      if(e.target.checked == true) {
        // チェーンウェイト加工が選択された場合、形態安定加工を無効化
        const formStabilizingOption = this.querySelector('[data-option-type-code="110"]');
        if(formStabilizingOption) {
          formStabilizingOption.disabled = true;
          formStabilizingOption.checked = false;
          formStabilizingOption.closest('.unico-order-option-wrapper').style.opacity = 0.5;
        }
      } else {
        // チェーンウェイト加工が解除された場合、ヒダタイプに応じて形態安定加工の状態を決定
        const formStabilizingOption = this.querySelector('[data-option-type-code="110"]');
        if(formStabilizingOption) {
          // ストレートの場合は無効のまま、1.5倍/2倍ヒダの場合は有効化
          if(!this.querySelector('[data-option-type-code="010"][data-option-code="3"][aria-checked="true"]')) {
            formStabilizingOption.disabled = false;
            formStabilizingOption.closest('.unico-order-option-wrapper').style.opacity = 1;
          }
        }
      }
    }
    if(e && e.target.dataset.optionTypeCode == '110') {
      // 形態安定加工の選択/解除時の処理
      if(e.target.checked == true) {
        // 形態安定加工が選択された場合、チェーンウェイト加工を無効化
        const chainWeightOption = this.querySelector('[data-option-type-code="150"]');
        if(chainWeightOption) {
          chainWeightOption.disabled = true;
          chainWeightOption.checked = false;
          chainWeightOption.closest('.unico-order-option-wrapper').style.opacity = 0.5;
        }
      } else {
        // 形態安定加工が解除された場合、チェーンウェイト加工を有効化
        const chainWeightOption = this.querySelector('[data-option-type-code="150"]');
        if(chainWeightOption) {
          chainWeightOption.disabled = false;
          chainWeightOption.closest('.unico-order-option-wrapper').style.opacity = 1;
        }
      }
    }
  }

  // 排他制御を必要に応じて適用する関数
  applyExclusiveControlIfNeeded() {
    const formStabilizingOption = this.querySelector('[data-option-type-code="110"]');
    const chainWeightOption = this.querySelector('[data-option-type-code="150"]');
    
    if(formStabilizingOption && chainWeightOption) {
      // 形態安定加工が選択されている場合、チェーンウェイト加工を無効化
      if(formStabilizingOption.checked) {
        chainWeightOption.disabled = true;
        chainWeightOption.checked = false;
        chainWeightOption.closest('.unico-order-option-wrapper').style.opacity = 0.5;
      }
      // チェーンウェイト加工が選択されている場合、形態安定加工を無効化
      else if(chainWeightOption.checked) {
        formStabilizingOption.disabled = true;
        formStabilizingOption.checked = false;
        formStabilizingOption.closest('.unico-order-option-wrapper').style.opacity = 0.5;
      }
    }
  }

  sendItemInfo(form) {
    const selectedProperties = this.querySelectorAll('unico-radio-button button[aria-checked="true"]');
    const selectedItems = this.querySelectorAll('.unico-order-option-wrapper input:checked');
    const selectedFinalWidth = this.querySelector('[data-target="order-final-width"]')
    const selectedFinalHeight = this.querySelector('[data-target="order-final-height"]')
    const selectedFinalWidth2 = this.querySelector('[data-sub-size="true"] [data-target="order-final-width"]')
    const selectedFinalHeight2 = this.querySelector('[data-sub-size="true"] [data-target="order-final-height"]')
    let targetSub = {};

    const array = {
      "_option_class1": this.currentOrderCategory.option_type1_code,
      "_option_class2": this.currentOrderCategory.option_type2_code,
      "_option_class3": this.currentOrderCategory.option_type3_code,
      "_option_class4": this.currentOrderCategory.option_type4_code,
      "_option_class5": this.currentOrderCategory.option_type5_code,
      "_option_class6": this.currentOrderCategory.option_type6_code,
      "_option_class7": this.currentOrderCategory.option_type7_code,
      "_option_class8": this.currentOrderCategory.option_type8_code,
      "_option_class9": this.currentOrderCategory.option_type9_code,
      "_option_class10": this.currentOrderCategory.option_type10_code,
    }
    let array2 = {}
    for(let i = 0; i < 10; i++) {
      if(array[`_option_class${i + 1}`] && this.querySelector(`button[aria-checked="true"][data-option-type-code="${array[`_option_class${i + 1}`]}"]`)) {
        array[`_option_code${i + 1}`] = this.querySelector(`button[aria-checked="true"][data-option-type-code="${array[`_option_class${i + 1}`]}"]`).dataset.optionCode || '0'
      } else if(array[`_option_class${i + 1}`] && this.querySelector(`.unico-order-option-wrapper input[data-option-type-code="${array[`_option_class${i + 1}`]}"]:checked`)) {
        array[`_option_code${i + 1}`] = this.querySelector(`.unico-order-option-wrapper input[data-option-type-code="${array[`_option_class${i + 1}`]}"]:checked`).value || '0'
      } else if(array[`_option_class${i + 1}`] && this.querySelector(`.unico-order-option-wrapper input[data-option-type-code="${array[`_option_class${i + 1}`]}"]`)) {
        array[`_option_code${i + 1}`] = array[`_option_class${i + 1}`] == '040' ? '1' : '0'
      } else if(array[`_option_class${i + 1}`] && !this.querySelector(`.unico-order-option-wrapper input[data-option-type-code="${array[`_option_class${i + 1}`]}"]`)){
        array[`_option_code${i + 1}`] = '0'
      } else {
        array[`_option_code${i + 1}`] = ""
      }
    }
    
    if(this.subOrderCategory) {
      array2 = {
        "_option_class1": this.subOrderCategory.option_type1_code,
        "_option_class2": this.subOrderCategory.option_type2_code,
        "_option_class3": this.subOrderCategory.option_type3_code,
        "_option_class4": this.subOrderCategory.option_type4_code,
        "_option_class5": this.subOrderCategory.option_type5_code,
        "_option_class6": this.subOrderCategory.option_type6_code,
        "_option_class7": this.subOrderCategory.option_type7_code,
        "_option_class8": this.subOrderCategory.option_type8_code,
        "_option_class9": this.subOrderCategory.option_type9_code,
        "_option_class10": this.subOrderCategory.option_type10_code,
      }
      
      
      for(let i = 0; i < 10; i++) {
        
        if(array2[`_option_class${i + 1}`] && this.querySelector(`button[aria-checked="true"][data-option-type-code="${array2[`_option_class${i + 1}`]}"]`)) {
          if(array2[`_option_class${i + 1}`] == '060') {
            array2[`_option_code${i + 1}`] = this.querySelector(`[data-option-type="990"] button[aria-checked="true"]`).dataset.optionCode
          } else {
            array2[`_option_code${i + 1}`] = this.querySelector(`button[aria-checked="true"][data-option-type-code="${array2[`_option_class${i + 1}`]}"]`).dataset.optionCode
          }
        } else if(array2[`_option_class${i + 1}`] && this.querySelector(`.unico-order-option-wrapper input[data-option-type-code="${array2[`_option_class${i + 1}`]}"]:checked`)) {
          array2[`_option_code${i + 1}`] = this.querySelector(`.unico-order-option-wrapper input[data-option-type-code="${array2[`_option_class${i + 1}`]}"]:checked`).value
        } else if(array2[`_option_class${i + 1}`] && this.querySelector(`.unico-order-option-wrapper input[data-option-type-code="${array2[`_option_class${i + 1}`]}"]`)) {
          array2[`_option_code${i + 1}`] = array2[`_option_class${i + 1}`] == '040' ? '1' : '0'
        } else {
          array2[`_option_code${i + 1}`] = ""
        }
      }

      for(let i = 0; i < 10; i++) {
        if(array2[`_option_class${i + 1}`] == '020' && array2[`_option_code${i + 1}`] == '2') {
          array2[`_option_code${i + 1}`] = "3"
        } else if(array2[`_option_class${i + 1}`] == '020' && array2[`_option_code${i + 1}`] == '3') {
          array2[`_option_code${i + 1}`] = "2"
        }
      }
    }
    
    
    for(let i = 0; i < 10; i++) {
      
      this.targetSizeTanka = window.OrderSizeTanka[this.dataset.orderId].records.filter((record) => {
        return record['option1_code'] == parseInt(array['_option_code1'] ? array['_option_code1'] : '0')
       })
      
      const baseTarget = findClosestValue(
        this.targetSizeTanka,
        selectedFinalWidth.textContent.replace('cm', ''),
        selectedFinalHeight.textContent.replace('cm', ''),
        'finish_width_horizontal',
        'finish_length_vertical',
        array['_option_code1'] ? array['_option_code1'] : 0
      )
      const tanka2 = window.OptionShubetu.find(record => record['option_type_code'] == array[`_option_class${i}`] && record['option_code'] == parseInt(array[`_option_code${i}`]))
      if(tanka2) {
        array['_su_price' + i] = tanka2['variable_sales_price'];
        array['_p_price' + i] = tanka2['variable_purchase_price'];
        if(this.subOrderCategory) {
          array2['_su_price' + i] = tanka2['variable_sales_price'];
          array2['_p_price' + i] = tanka2['variable_purchase_price'];
        }
      } 

      let tanka = []
      if(this.currentOption && this.dataset.category != '020') {
        tanka = window.OrderSizeOptionTanka[this.dataset.category].records.filter(s => s['option1_code'] == array['_option_code1'] && s['option_code'] == parseInt(array[`_option_code${i}`]) && s['option_type_code'] == parseInt(array[`_option_class${i}`]))
      }
      if(tanka && tanka.length > 0) {
        
        const test2 = findClosestValue(
          tanka,
          selectedFinalWidth.textContent.replace('cm', ''),
          selectedFinalHeight.textContent.replace('cm', ''),
          'finish_width_horizontal',
          'finish_length_vertical',
          array['_option_code1'] ? array['_option_code1'] : 0
        )
        if(test2) {
          array['_su_price' + i] = test2['sales_base_unit_price'];
          array['_p_price' + i] = test2['purchase_base_unit_price'];
          if(this.subOrderCategory) {
            array2['_su_price' + i] = tanka2['sales_base_unit_price'];
            array2['_p_price' + i] = tanka2['purchase_base_unit_price'];
          }
        } else {
          array['_su_price' + i] = 0;
          array['_p_price' + i] = 0;
          if(this.subOrderCategory) {
            array2['_su_price' + i] = 0;
            array2['_p_price' + i] = 0;
          }
        }
      }
      array['_su_price1'] = baseTarget['sales_base_unit_price'];
      array['_p_price1'] = baseTarget['purchase_base_unit_price'];
      if(this.subOrderCategory) {
        // サブ生地の調整されたサイズを使用
        const subWidth = selectedFinalWidth2 ? parseInt(selectedFinalWidth2.textContent.replace('cm', '')) : this.size.width;
        const subHeight = selectedFinalHeight2 ? parseInt(selectedFinalHeight2.textContent.replace('cm', '')) : this.size.height;
        
        targetSub = findClosestValue(
          this.targetSubSizeTanka,
          subWidth,
          subHeight,
          'finish_width_horizontal',
          'finish_length_vertical',
          this.currentOption ? this.currentOption.dataset.optionCode : 0,
        )
        array2['_su_price1'] = targetSub['sales_base_unit_price'];
        array2['_p_price1'] = targetSub['purchase_base_unit_price'];
      }
      
    }

    let addItems = [];
    const properties = {}
    const properties2 = {}

    
    for(let property of selectedProperties) {
      if(!property.hasAttribute('data-sub-product') && !property.hasAttribute('data-order-id')) {
        properties[property.dataset.optionName] = property.dataset.optionValue
        properties2[property.dataset.optionName] = property.dataset.optionValue
        if(property.dataset.optionTypeCode) {
          properties['_' + property.dataset.optionTypeCode] = property.dataset.optionCode
          properties2['_' + property.dataset.optionTypeCode] = property.dataset.optionCode
          if(property.dataset.optionTypeCode == '020' && property.dataset.optionCode == "2") {
            properties2['_' + property.dataset.optionTypeCode] = "3"
          } else if(property.dataset.optionTypeCode == '020' && property.dataset.optionCode == "3") {
            properties2['_' + property.dataset.optionTypeCode] = "2"
          }
          continue
        }
      } 
    }

    if(selectedFinalWidth) {
      properties['仕上がり幅(横)'] = selectedFinalWidth.textContent
      properties['仕上がり丈(縦)'] = selectedFinalHeight.textContent
      properties['_width'] = selectedFinalWidth.textContent.replace('cm', '')
      properties['_height'] = selectedFinalHeight.textContent.replace('cm', '')
      properties2['仕上がり幅(横)'] = selectedFinalWidth2.textContent
      properties2['仕上がり丈(縦)'] = selectedFinalHeight2.textContent
      properties2['_width'] = selectedFinalWidth2.textContent.replace('cm', '')
      properties2['_height'] = selectedFinalHeight2.textContent.replace('cm', '')
    }
    // console.log({...properties, ...properties2})
    // console.log(properties, properties2)
    // console.log(array, array2)

    let option = false
    for(let item of selectedItems) {
      if(item.dataset.optionTypeCode) {
        properties['_' + item.dataset.optionTypeCode] = item.value
        properties['_variant_id_' + item.dataset.optionTypeCode] = item.dataset.variantId
        if(option == false) {
          option = item.dataset.name + ','  
        } else {
          option += item.dataset.name + ','
        }
        
      }

      addItems.push({
        id: item.dataset.variantId,
        quantity: 1,
        properties: {
          "_option_type_code": item.dataset.optionTypeCode,
          "_option_type_value": item.value,
        }
      });
    }

    if(option) {
      properties['オプション'] = option.split(',').slice(0, -1).join(',')
    }
    
    addItems.push({
      id: form.querySelector('[name="items[0][id]"]').value,
      quantity: 1,
      properties: {...properties, ...array}
    })
    if(this.subOrderCategory) {
      const doubleType = this.querySelector('.unico-product-step-block:has([data-option-type="999"])')
      const subVariants = JSON.parse(doubleType.querySelector('[aria-checked="true"]').dataset.optionProduct)
      const addPrice = targetSub['sales_base_unit_price'];
      
      const targetVariant = subVariants.find(variant => {
        if(variant.compare_at_price) {
          return variant.compare_at_price == ((Math.trunc(addPrice * 1.1)) * 100)
        } else {
          return variant.price == ((Math.trunc(addPrice * 1.1)) * 100)
        }
      });
      for(let property of selectedProperties) {
        if(property.hasAttribute('data-sub-product')) {
          properties2[property.dataset.optionName] = property.dataset.optionValue
          if(property.dataset.optionTypeCode) {
            properties2['_' + property.dataset.optionTypeCode] = property.dataset.optionCode          
            continue
          }
        }
      }
      addItems.push({
        id: targetVariant.id,
        quantity: 1,
        properties: {...properties2, ...array2}
      })
    }
      
    for(let property of selectedProperties) {
      if(property.hasAttribute('data-sub-product')) {
        properties2[property.dataset.optionName] = property.dataset.optionValue
        if(property.dataset.optionTypeCode) {
          properties2['_' + property.dataset.optionTypeCode] = property.dataset.optionCode          
          continue
        }
      }
    }
    
    return addItems
  }

  subPriceLogic(subPriceElm) {
    const priceElm = this.querySelector('.unico-product-price-main');
    this.subOrderCategory = window.OrderCategory.find(value => 
      {
        return String(value['order_category_code']).toString().padStart(3, '0') == String(subPriceElm.dataset.categoryCode).toString().padStart(3, '0')
      });
    
    this.subOption = this.querySelector(`button[aria-checked="true"][data-option-type-code="${this.subOrderCategory['option_type1_code']}"]`)
    
    if(!this.subOption) return
    if(this.subOption) {
      this.targetSubSizeTanka = window.OrderSizeTanka[subPriceElm.dataset.orderId].records.filter((record) => record['option1_code'] == parseInt(this.subOption.dataset.optionCode))
    } else {
      this.targetSubSizeTanka = window.OrderSizeTanka[subPriceElm.dataset.orderId].records.filter((record) => record['option1_code'] == 0)
    }
    
    this.querySelector('[data-option-value="カーテンレール（天井付け）"]').classList.add('hidden')
    if(this.querySelector('[data-option-value="カーテンレール（天井付け）"][aria-checked="true"]')) {
      this.querySelector('[data-option-value="カーテンレール（天井付け）"]').setAttribute('aria-checked', 'false')
      this.querySelector('[data-option-value="内側（天井付け）"]').setAttribute('aria-checked', 'true')
    }
    
    const width = parseInt(this.querySelector('input[name="curtain-width"]').value) || 100;
    const height = parseInt(this.querySelector('input[name="curtain-height"]').value) || 100;
    const size = this.sendSize(width, height, this.subOption ? this.subOption.dataset.optionCode : 0);

    const target = findClosestValue(
      this.targetSubSizeTanka,
      size.width,
      size.height,
      'finish_width_horizontal',
      'finish_length_vertical',
      this.subOption ? this.subOption.dataset.optionCode : 0,
    )

    this.querySelector('.table[data-sub-item="true"]').textContent = subPriceElm.querySelector('span').textContent;
    priceElm.dataset.subPrice = Math.trunc(target['sales_base_unit_price'] * 1.1)
    const optionVariants = JSON.parse(subPriceElm.dataset.optionProduct)
    
    const targetVariant = optionVariants.find(e => e.compare_at_price ? e.compare_at_price : e.price == Math.trunc(target['sales_base_unit_price'] * 1.1) * 100)

    subPriceElm.dataset.variantId = targetVariant.id
  }
  removeSubPriceLogic() {
    this.querySelector('unico-radio-button[data-option-type="999"]').closest('.unico-product-step-block').classList.add('hidden');
    this.querySelector('unico-radio-button[data-option-type="990"]').closest('.unico-product-step-block').classList.add('hidden');
    this.querySelector('.unico-order-table[data-sub-item]').classList.add('hidden');
    this.querySelector('.table[data-sub-item="true"]').classList.add('hidden');
    this.querySelector('.table[data-sub-item="false"]').classList.add('hidden');
    this.querySelector(`button[aria-checked="true"][data-category-code]`).removeAttribute('aria-checked');
    if(this.querySelector(`button[aria-checked="true"][data-sub-product]`)) {
      this.querySelector(`button[aria-checked="true"][data-sub-product]`).removeAttribute('aria-checked');
    }
    const priceElm = this.querySelector('.unico-product-price-main');
    priceElm.dataset.subPrice = 0;
  }

  addSubPriceLogic() {
    this.querySelector('unico-radio-button[data-option-type="999"]').closest('.unico-product-step-block').classList.remove('hidden');
    this.querySelector('unico-radio-button[data-option-type="990"]').closest('.unico-product-step-block').classList.remove('hidden');
    this.querySelector('.unico-order-table[data-sub-item]').classList.remove('hidden');
    this.querySelector('.table[data-sub-item="true"]').classList.remove('hidden');
    this.querySelector('.table[data-sub-item="false"]').classList.remove('hidden');
    this.querySelector('unico-radio-button[data-option-type="999"] button').setAttribute('aria-checked', 'true');
    this.querySelector('unico-radio-button[data-option-type="990"] button').setAttribute('aria-checked', 'true');
  }

  sendSize(width, height, optionCode, subFlg = false) {
    const targetWindow = this.querySelector('[data-target-option="window"] button[aria-checked="true"]')
    let targetCurtainType = targetWindow.closest('unico-radio-button').dataset.targetType
    const targetPosition = this.querySelector('[data-option-type="050"] button[aria-checked="true"]')
    if(subFlg == true) {
      if (targetCurtainType == '1') {
        targetCurtainType = '2'
      } else {
        targetCurtainType = '1'
      }
    }
    const target = targetWindow.dataset.optionValue;
    const position = targetPosition.dataset.optionCode;
    
    if(
      this.dataset.category == '010' && optionCode != '3' || 
      this.dataset.category == '011' && optionCode != '3' || 
      this.dataset.category == '012' && optionCode != '3' || 
      this.dataset.category == '013' && optionCode != '3' || 
      this.dataset.category == '014' && optionCode != '3'
    ) {
      if(width > 200 && 300 >= width) {
        width = Math.trunc(width * 1.03);
      } else if(width > 300 && 560 >= width) {
        width = Math.trunc(width + 10);
      } else {
        width = Math.trunc(width * 1.05);
      }
      if(target == '腰窓') {
        height = height + parseInt(targetWindow.dataset.heightAddition || 0);
      } else if(targetCurtainType == '1') {
        height = height - 1;
      } else {
        height = height - 2;
      }      
    } else if (
      this.dataset.category == '010' && optionCode == '3' || 
      this.dataset.category == '011' && optionCode == '3' || 
      this.dataset.category == '012' && optionCode == '3' || 
      this.dataset.category == '013' && optionCode == '3' || 
      this.dataset.category == '014' && optionCode == '3'
    ) {
      width = Math.ceil(width * 1.1) + 5;
      if(target == '腰窓') {
        height = height + parseInt(targetWindow.dataset.heightAddition || 0);
      } else if(targetCurtainType == '1') {
        height = height - 1;
      } else {
        height = height - 2;
      }
    } else if (this.dataset.category == '020') {
      
      const doubleShadeFlg = this.querySelector('[data-option-type-code="020"][data-option-code="2"][aria-checked="true"]') || this.querySelector('[data-option-type-code="020"][data-option-code="3"][aria-checked="true"]') ? true : false
      
      if(targetPosition.dataset.optionValue == 'カーテンレール（天井付け）') {
        width = width
        if(target == '腰窓') {
          if (targetCurtainType == '1') {
            height = height + parseInt(targetWindow.dataset.heightAddition || 0);
          } else {
            height = height + parseInt(targetWindow.dataset.heightAddition || 0);
            if(doubleShadeFlg) {
              height = --height;
            }
          }
        } else {
          if (targetCurtainType == '1') {
            height = height - 1;
          } else {
            if(doubleShadeFlg) {
              height = height - 2;
            } else {
              height = height - 1;
            }
          }
        }
      } else if(targetPosition.dataset.optionValue == '壁（正面付け）') {
        width = Math.ceil(width * 1.05);
        if(target == '腰窓') {
          if (targetCurtainType == '1') {
            height = height + parseInt(targetWindow.dataset.heightAddition || 0);
          } else {
            height = height + parseInt(targetWindow.dataset.heightAddition || 0);
            if(doubleShadeFlg) {
              height = --height;
            }
          }
        } else {
          if (targetCurtainType == '1') {
            height = height - 1;
          } else {
            if(doubleShadeFlg) {
              height = height - 2;
            } else {
              height = height - 1;
            }
          }
        }
      } else {
        width = Math.trunc(width) - 1;
        if (targetCurtainType == '1') {
          height = height - 1;
        } else {
          if(doubleShadeFlg) {
            height = height - 2;
          } else {
            height = height - 1;
          }
        }
      }
      
    } else if (this.dataset.category == '030') {
      if(targetPosition.dataset.optionValue == 'カーテンレール（天井付け）') {
        width = width
        if(target == '腰窓') {
          if (targetCurtainType == '1') {
            height = height + parseInt(targetWindow.dataset.heightAddition || 0);
          } else {
            height = height + parseInt(targetWindow.dataset.heightAddition || 0);
          }
        } else {
          if (targetCurtainType == '1') {
            height = height - 1;
          } else {
            height = height - 1
          }
        }
      } else if(targetPosition.dataset.optionValue == '壁（正面付け）') {
        width = Math.ceil(width * 1.05);
        if(target == '腰窓') {
          if (targetCurtainType == '1') {
            height = height + parseInt(targetWindow.dataset.heightAddition || 0);
          } else {
            height = height + parseInt(targetWindow.dataset.heightAddition || 0);
          }
        } else {
          if (targetCurtainType == '1') {
            height = height - 1;
          } else {
            height = height - 1
          }
        }
      } else {
        width = Math.trunc(width) - 1;
        if (targetCurtainType == '1') {
          height = height - 1;
        } else {
          height = height - 1
        }
      }
    }
    const size = {
      width: width,
      height: height,
    };

    // 両開き選択中の場合、幅が奇数の場合は1cm足す
    if(this.querySelector('[data-option-type-code="030"]') && this.querySelector('[data-option-type-code="030"][aria-checked="true"][data-option-code="1"]')) {
      if(size.width % 2 != 0) {
        size.width = size.width + 1
      }
    }
    
    return size;
  }
  
  // 排他制御を必要に応じて適用する関数
  applyExclusiveControlIfNeeded() {
    const formStabilizingOption = this.querySelector('[data-option-type-code="110"]');
    const chainWeightOption = this.querySelector('[data-option-type-code="150"]');
    
    if(formStabilizingOption && chainWeightOption) {
      // 形態安定加工が選択されている場合、チェーンウェイト加工を無効化
      if(formStabilizingOption.checked) {
        chainWeightOption.disabled = true;
        chainWeightOption.checked = false;
        chainWeightOption.closest('.unico-order-option-wrapper').style.opacity = 0.5;
      }
      // チェーンウェイト加工が選択されている場合、形態安定加工を無効化
      else if(chainWeightOption.checked) {
        formStabilizingOption.disabled = true;
        formStabilizingOption.checked = false;
        formStabilizingOption.closest('.unico-order-option-wrapper').style.opacity = 0.5;
      }
    }
  }
}
document.addEventListener('DOMContentLoaded', () => {
  customElements.define('wl-order-section', WLOrderSection);
});


class WLHeaderSearch extends HTMLElement {
  constructor() {
    super();
    this.searchFormArea = document.querySelector('[data-target-id="search-form-area"]');
    this.searchButton = document.querySelector('[data-target-id="search-button"]');
    this.searchForm = this.searchFormArea.querySelector('.unico-search-form');
    this.searchInput = this.querySelector('.unico-search-input');
    this.searchCloseButton = this.searchFormArea.querySelector('.unico-header-search-close');

    this.searchInput.addEventListener('input', (e) => {
      inputTimeout = setTimeout(() => {
        this.inputSearch(e);
      }, 300);
      clearTimeout(inputTimeout);
    });

    this.searchButton.addEventListener('click', this.toggleSearchForm.bind(this));
    this.searchCloseButton.addEventListener('click', this.toggleSearchForm.bind(this));
    // 指定した範囲以外をクリックした場合に検索フォームを閉じる
    
    document.addEventListener('click', (e) => {
      
      if (!this.contains(e.target)) {
        this.classList.remove('is-active');
      }
    });
  }

  toggleSearchForm() {
    this.classList.toggle('is-active');
    this.searchInput.focus();
  }
  inputSearch(e) {
    
    this.classList.add('is-active');
    return new Promise(() => {
      fetch(window.Shopify.routes.root + 'search?q=' + e.target.value + '&type=product&view=suggest')
        .then((response) => response.text())
        .then((suggestions) => {
    
          const result = this.querySelector('.result');
          result.innerHTML = suggestions;
        });
    });
  }
}
customElements.define('wl-header-search', WLHeaderSearch);

(() => {
  if(
    document.querySelector('wl-order-section') && document.querySelector('wl-order-section').dataset.category != '' ||
    document.querySelector('wl-order-section') && document.querySelector('wl-order-section').dataset.template == 'cart'
  ) {
    window.OrderSizeOptionTanka = getOrderSizeOptionTanka();
    window.OrderCategory = getOrderCategory();
    window.OptionShubetu = getOptionShubetu();
    window.OrderSizeTanka = getOrderSizeTanka();  
  } else {
    window.OrderSizeOptionTanka = []
    window.OrderCategory = []
    window.OptionShubetu = []
    window.OrderSizeTanka = []
  }
  
})()

class WLOrderCheck extends HTMLElement {
  constructor() {
    super();
    
  }
  connectedCallback() {
    this.items = JSON.parse(this.dataset.items)
    this.check();
  }
  check() {
    const orderOptionItems = this.items.filter(item => item.properties['_option_type_code'])
    const updates = {}
    let updateFlg = false
    
    for(let optionItem of orderOptionItems) {
      const optionTypeCode = optionItem.properties['_option_type_code']
      const optionValue = optionItem.properties['_option_type_value']
      const targetItems = this.items.filter(item => {
        return item.properties['_variant_id_' + optionTypeCode] && 
        parseInt(item.properties['_variant_id_' + optionTypeCode]) == optionItem.id && 
        item.properties['_' + optionTypeCode] == optionValue
      })
      
      let totalAmount = 0
      for (let targetItem of targetItems) {
        totalAmount += targetItem.quantity
      }
      
      // オプションと商品の数量が一致しているか確認
      if(optionItem.quantity !== totalAmount) {
        updates[optionItem.key] = totalAmount
        updateFlg = true
      }
    }
    if(updateFlg) this.updateQuantity(updates)
  }
  updateQuantity(updates) {
    const updateProductObj = {
      updates: updates,
      sections: WLCart.getSectionsToRender().map((s) => s.section),
      sections_url: window.location.pathname,
    };

    return new Promise((resolve) => {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateProductObj),
      })
        .then((response) => response.json())
        .then((cart) => {
          WLCart.renderNewSections(cart.sections);
          document.querySelector('unico-modal[data-target-id="order-option-change-modal"] dialog').showModal()
        });
    });
  }
  
}
customElements.define('wl-order-check', WLOrderCheck);
            